export default __webpack_public_path__ + "static/media/exterior2.5ec1ad7d.jpg";